var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    attrs: { rules: _vm.validationRules, tag: "div", vid: _vm.$attrs.id },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                class: [
                  { "error-styles": errors[0] },
                  "lf-switch-container",
                  {
                    "disabled-field": _vm.disabled,
                    "lf-custom-switch-style": _vm.customStyle,
                  },
                ],
              },
              [
                _vm.customStyle
                  ? _c(
                      "div",
                      { staticClass: "lf-custom-switch-style-container" },
                      [
                        _c("span", {
                          class: [
                            _vm.customStyle.icon,
                            "lf-custom-switch-style-icon",
                          ],
                        }),
                        _c("span", {
                          staticClass: "lf-custom-switch-style-text",
                          domProps: { innerHTML: _vm._s(_vm.customStyle.text) },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm.customStyle ? _c("v-spacer") : _vm._e(),
                _c("div", [
                  _vm.label
                    ? _c(
                        "div",
                        {
                          staticClass: "lf-switch label-container",
                          on: { click: _vm.emitClickEvent },
                        },
                        [
                          _c(
                            "v-switch",
                            _vm._b(
                              {
                                class: _vm.innerValue ? "on" : "off",
                                attrs: {
                                  id: _vm.id,
                                  label: _vm.label,
                                  disabled: _vm.disabled,
                                  ripple: false,
                                },
                                on: { change: _vm.emitValue },
                                model: {
                                  value: _vm.innerValue,
                                  callback: function ($$v) {
                                    _vm.innerValue = $$v
                                  },
                                  expression: "innerValue",
                                },
                              },
                              "v-switch",
                              _vm.$attrs,
                              false
                            )
                          ),
                          _vm.requiredField
                            ? _c("span", { staticClass: "required-field" }, [
                                _vm._v("*"),
                              ])
                            : _vm._e(),
                          _vm.showInfo
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: {
                                    top: "",
                                    color: "primary",
                                    dark: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "span",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    class: [
                                                      _vm.icons.info,
                                                      "label-icon",
                                                    ],
                                                  },
                                                  "span",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "show-info-message" },
                                    [_vm._v(_vm._s(_vm.showInfo))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "messages-container" }, [
                    errors.length
                      ? _c("span", { staticClass: "alert-message" }, [
                          _vm._v(_vm._s(errors[0])),
                        ])
                      : _c("span", { staticClass: "help-message" }, [
                          _vm._v(_vm._s(_vm.helpText)),
                        ]),
                  ]),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }